import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import {
  ThemeProvider,
  I18TransalteProvider,
  ReactQueryProvider,
  DataAPIProvider,
  UserProvider,
  AuthProvider,
} from "./providers";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <>
    <Toaster position="top-center" />
    <RecoilRoot>
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <UserProvider>
              <DataAPIProvider>
                <I18TransalteProvider>
                  <ReactQueryProvider>
                    <App />
                  </ReactQueryProvider>
                </I18TransalteProvider>
              </DataAPIProvider>
            </UserProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </RecoilRoot>
  </>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
